import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'actionMethodConversion',
    standalone: false
})
export class MethodFilterPipe implements PipeTransform {

  transform(value: any): any {
    switch (value) {
      case "Item minted":
      case "create_item":
        return "Asset Minted.";
        break;
      case "Purchased sell order":
      case "purchase_item":
        return "Purchase Asset.";
        break;
      case "Item updated":
        return "Manually Updated.";
        break;
      case "Accepted item bid":
      case "Accept_item_bid":
        return "Accept Bid.";
        break;
      default:
        return value
        break;
    }
  }

}
